import EVENTS from '@/utils/Constants/Events';
import GigyaController from '@/utils/Controllers/Gigya/GigyaController';
import { handleModalWorkflows } from '@/utils/Controllers/Gigya/Utils';
import { goRegister } from '@/utils/Common/Redirects';

const CONTAINER_ID = 'js-dlg-gigya-login-container';

export default class GigyaLoginController {
  static screenSetConfig = {
    startScreen: DLG.gigya.loginScreenId,
    containerID: CONTAINER_ID,
    onBeforeScreenLoad: GigyaLoginController.onBeforeScreenLoad,
  };

  static init() {
    DLG.EVE.on(EVENTS.GIGYA.REDIRECT.LOGIN, GigyaLoginController.refreshLogin);
    DLG.EVE.on(EVENTS.GIGYA.REDIRECT.REGISTER, goRegister);
    GigyaController.listenToLogin();
    GigyaController.loadScreen(GigyaLoginController.screenSetConfig);
  }

  static onBeforeScreenLoad(res) {
    let interval;
    let intervalC = 0;
    const intervalM = 30;
    (() => {
      interval = setInterval(() => {
        const form = document.getElementById('gigya-login-form');
        if (intervalC > intervalM) {
          clearInterval(interval);
        } else if (form !== null) {
          clearInterval(interval);
          const inputEmail = form.querySelectorAll('[name="username"]');
          inputEmail[0].setAttribute('type', 'email');
        }
        intervalC += 1;
      }, 1000);
    })();
    return handleModalWorkflows(res);
  }

  static refreshLogin() {
    const popup = document.querySelector('.dln-popup.dln-popup--open');
    if (popup) {
      DLG.EVE.emit(EVENTS.MODAL.CLOSE, { popup });
    }
  }
}
